import type { TeamDetailsTab } from './types';

export const INITIAL_TAB: TeamDetailsTab = 'active';

export const TEST_ID = 'teamDetailsTabs';
